import * as React from 'react';
import { RenderHeader } from '../../../functions/SkeletonCodeFunctions/WidgetSkeletonCode';
import Select from 'react-select';
import { reactSelectBasicStyle } from '../../../style/select-constants';


export default class PayrollReportingGenerationWidget extends React.Component<{}, {}> {

    constructor(props: {}) {
        super(props);
    }


    render(): JSX.Element {
        return (
            <>
                {RenderHeader("Payroll Report Generation")}
                <Select
                    styles={reactSelectBasicStyle}
                    options={[]}
                    value={{ label: "Select Report", value: "" }}
                    onChange={() => { }}
                    menuPlacement="auto"
                    menuPosition="fixed"
                />
                <hr />
            </>
        )
    }
}
